import React, { useState, useEffect } from 'react'
import './OurProducts.scss'
import { Link } from 'react-router-dom'

import 'aos/dist/aos.css'
import Aos from 'aos'

import { useNavigate } from 'react-router-dom'

import LazyLoad from 'react-lazy-load'

export default function OurProducts() {
  const [text, setText] = useState(false)

  const navigation = useNavigate()

  const ourProductHandler = () => {
    setText(true)
  }

  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='ourProductsAr' data-aos= 'fade-right'>
      <LazyLoad height={500} offset={300}>
        <div className="ourProducts_image">
        </div>
      </LazyLoad>
      <div className='container'>
        <div className='row'>
          <div className="ourProducts_contents">
            <div className="ourProducts_contents_title">
              منتجاتنا 
            </div>
            <div className="ourProducts_contents_subtitle">
              <div style={text ? { display: 'none' } : { display: '' }}>
                وتعمل الشركات الشريكة الرائدة في قطاع صناعة الصلب، ويضم مصنع الإنتاج خطين للدرفلة على الساخن بطاقة إجمالية تبلغ حوالي نصف مليون طن سنويًا . <br /><Link onClick={ourProductHandler}>أكثر ...</Link>
              </div>
              <div style={text ? { display: '' } : { display: 'none' }}>
                وتعمل الشركات الشريكة الرائدة في قطاع صناعة الصلب، ويضم مصنع الإنتاج خطين للدرفلة على الساخن بطاقة إجمالية تبلغ حوالي نصف مليون طن سنويًا.<br />
                تتكون مجموعة المنتجات الحالية من مجموعة من درجات وأحجام الفولاذ عالية الجودة (5.5 - 40 ملم) على شكل قضبان سلكية عادية ومضلعة وقضبان تستخدم في التطبيقات الصناعية المعقدة مثل السيارات والطاقة والهندسة الميكانيكية وكذلك البناء.
              </div>
            </div>
            <div className='buttons'>
              <div className='row_buttons'>
                <div className='button'>
                  <div className='contents' onClick={() => navigation('/ar/wirerod')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      قضبان الأسلاك
                    </div>
                  </div>
                </div>

                <div className='button2'>
                  <div className='contents' onClick={() => navigation('/ar/steelrebar')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      حديد التسليح
                    </div>
                  </div>
                </div>
              </div>

              <div className='row_buttons'>
                <div className='button3'>
                  <div className='contents' onClick={() => navigation('/ar/standardgalvanizedwire')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      الأسلاك المجلفنة <br />
                      القياسية
                    </div>
                  </div>
                </div>

                <div className='button4'>
                  <div className='contents' onClick={() => navigation('/ar/steelingot')}>
                    <div className='buttons_img'>  
                    </div>
                    <hr />
                    <div className='buttons_title'>
                      سبيكة الصلب (البليت)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
